<template>

<footer class="text-center">
            <p class="text-sm dark:text-light/70">
                💛💕 2024.焦晋源 Krin | Email：krinchao@gmail.com
            </p>
        </footer>
</template>